import { render, staticRenderFns } from "./Privacidade.vue?vue&type=template&id=4a77e5b4&scoped=true"
import script from "./Privacidade.vue?vue&type=script&lang=js"
export * from "./Privacidade.vue?vue&type=script&lang=js"
import style0 from "./Privacidade.vue?vue&type=style&index=0&id=4a77e5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77e5b4",
  null
  
)

export default component.exports